var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 300,
    height: 300,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,45H8a1,1,0,0,1-1-1V32a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V44A1,1,0,0,1,16,45ZM9,43h6V33H9Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,39H23a1,1,0,0,1,0-2h4.5a1.48,1.48,0,0,0,1.06-.44,2.11,2.11,0,0,0,.19-.23A1.5,1.5,0,0,0,27.5,34H17v4a1,1,0,0,1-2,0V33a1,1,0,0,1,1-1H27.5a3.5,3.5,0,0,1,2.9,5.46A3.13,3.13,0,0,1,30,38,3.5,3.5,0,0,1,27.5,39Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.86,44H16a1,1,0,0,1-1-1V38a1,1,0,0,1,2,0v4H27.86a8.94,8.94,0,0,0,6.36-2.64l4.57-4.57a1.12,1.12,0,0,0-1.58-1.58l-1.86,1.86a10,10,0,0,1-5.23,2.75L30,38a3.5,3.5,0,0,1-2.47,1H23a1,1,0,0,1,0-2h4.5a1.48,1.48,0,0,0,1.06-.44,2.11,2.11,0,0,0,.19-.23,1,1,0,0,1,.68-.42,8,8,0,0,0,4.5-2.26l1.86-1.86a3.14,3.14,0,0,1,4.42,0,3.14,3.14,0,0,1,0,4.42l-4.57,4.57A10.92,10.92,0,0,1,27.86,44Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.64,30H18.36a7.36,7.36,0,0,1-5.2-12.57l9.13-9.14A1,1,0,0,1,23,8h2a1,1,0,0,1,.71.29l9.13,9.14A7.36,7.36,0,0,1,29.64,30ZM23.41,10l-8.84,8.84A5.37,5.37,0,0,0,18.36,28H29.64a5.37,5.37,0,0,0,3.79-9.16L24.59,10Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10a4.68,4.68,0,0,1-4.57-3.75L19,4.2a1,1,0,0,1,.21-.83A1,1,0,0,1,20,3h8a1,1,0,0,1,.77.37A1,1,0,0,1,29,4.2l-.41,2.05A4.68,4.68,0,0,1,24,10ZM21.22,5l.17.86a2.66,2.66,0,0,0,5.22,0L26.78,5Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,10H21a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,11a1.25,1.25,0,0,1-.32-.05l-3-1a1,1,0,1,1,.64-1.9l3,1A1,1,0,0,1,31,10.32,1,1,0,0,1,30,11Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,10a1,1,0,0,1-.55-1.83l3-2a1,1,0,1,1,1.1,1.66l-3,2A.94.94,0,0,1,27,10Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,17a1,1,0,0,1-1-1V14a1,1,0,0,1,2,0v2A1,1,0,0,1,24,17Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,27a1,1,0,0,1-1-1V24a1,1,0,0,1,2,0v2A1,1,0,0,1,24,27Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,25H23a3,3,0,0,1-3-3,1,1,0,0,1,2,0,1,1,0,0,0,1,1h2a1,1,0,0,0,0-2H23a3,3,0,0,1,0-6h2a3,3,0,0,1,3,3,1,1,0,0,1-2,0,1,1,0,0,0-1-1H23a1,1,0,0,0,0,2h2a3,3,0,0,1,0,6Z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.387b410d97d5e80344a9b281ab66963c.svg";
export { ForwardRef as ReactComponent };